var _rect, _ellipse, _ellipse2, _ellipse3, _path, _path2, _path3, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunnySnail5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "#4EA86B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 100,
    rx: 70,
    ry: 50,
    fill: "#3A7F4E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 80,
    rx: 100,
    ry: 60,
    fill: "#3A7F4E"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 350,
    cy: 100,
    rx: 80,
    ry: 55,
    fill: "#3A7F4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150,200 C100,150 200,100 250,150 C300,200 200,250 150,200 Z",
    fill: "#64AF80",
    stroke: "#3A7F4E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150,200 C170,180 200,180 220,190",
    fill: "none",
    stroke: "#3A7F4E",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250,150 C230,170 210,175 180,180",
    fill: "none",
    stroke: "#3A7F4E",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(180, 190) scale(1.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-50,20 C-20,15 10,15 40,20 L40,40 C10,35 -20,35 -50,40 Z",
    fill: "#FBEEE6",
    stroke: "#E59866",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50,20 C-55,10 -50,0 -40,0 C-30,0 -25,10 -30,20",
    fill: "#FBEEE6",
    stroke: "#E59866",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -10,
    r: 35,
    fill: "#E67E22",
    stroke: "#A04000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -10,
    rx: 25,
    ry: 20,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -10,
    rx: 18,
    ry: 14,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -10,
    rx: 10,
    ry: 8,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -10,
    rx: 5,
    ry: 4,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -45,
    y1: 0,
    x2: -50,
    y2: -15,
    stroke: "#E59866",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -35,
    y1: 0,
    x2: -30,
    y2: -15,
    stroke: "#E59866",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -50,
    cy: -15,
    r: 5,
    fill: "white",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -30,
    cy: -15,
    r: 5,
    fill: "white",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52,-15 C-50,-18 -47,-18 -45,-15",
    stroke: "black",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32,-15 C-30,-18 -27,-18 -25,-15",
    stroke: "black",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45,10 C-40,15 -35,15 -30,10",
    fill: "none",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120, 250) scale(0.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-50,20 C-20,15 10,15 40,20 L40,40 C10,35 -20,35 -50,40 Z",
    fill: "#FBEEE6",
    stroke: "#E59866",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50,20 C-55,10 -50,0 -40,0 C-30,0 -25,10 -30,20",
    fill: "#FBEEE6",
    stroke: "#E59866",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -10,
    r: 35,
    fill: "#E67E22",
    stroke: "#A04000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -10,
    rx: 25,
    ry: 20,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -10,
    rx: 18,
    ry: 14,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -10,
    rx: 10,
    ry: 8,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -10,
    rx: 5,
    ry: 4,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -45,
    y1: 0,
    x2: -50,
    y2: -15,
    stroke: "#E59866",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -35,
    y1: 0,
    x2: -30,
    y2: -15,
    stroke: "#E59866",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -50,
    cy: -15,
    r: 5,
    fill: "white",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -30,
    cy: -15,
    r: 5,
    fill: "white",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52,-15 C-50,-18 -47,-18 -45,-15",
    stroke: "black",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32,-15 C-30,-18 -27,-18 -25,-15",
    stroke: "black",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45,10 C-40,15 -35,15 -30,10",
    fill: "none",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(270, 220) scale(0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-50,20 C-20,15 10,15 40,20 L40,40 C10,35 -20,35 -50,40 Z",
    fill: "#FBEEE6",
    stroke: "#E59866",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50,20 C-55,10 -50,0 -40,0 C-30,0 -25,10 -30,20",
    fill: "#FBEEE6",
    stroke: "#E59866",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -10,
    r: 35,
    fill: "#E67E22",
    stroke: "#A04000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-10 A25,25 0 0 1 -25,-35 A25,25 0 0 1 0,-10",
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-10 A15,15 0 0 1 -15,-25 A15,15 0 0 1 0,-10",
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-10 A8,8 0 0 1 -8,-18 A8,8 0 0 1 0,-10",
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -45,
    y1: 0,
    x2: -50,
    y2: -15,
    stroke: "#E59866",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -35,
    y1: 0,
    x2: -30,
    y2: -15,
    stroke: "#E59866",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -50,
    cy: -15,
    r: 5,
    fill: "white",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -30,
    cy: -15,
    r: 5,
    fill: "white",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52,-15 C-50,-18 -47,-18 -45,-15",
    stroke: "black",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32,-15 C-30,-18 -27,-18 -25,-15",
    stroke: "black",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45,10 C-40,15 -35,15 -30,10",
    fill: "none",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(330, 260) scale(0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-50,20 C-20,15 10,15 40,20 L40,40 C10,35 -20,35 -50,40 Z",
    fill: "#FBEEE6",
    stroke: "#E59866",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50,20 C-55,10 -50,0 -40,0 C-30,0 -25,10 -30,20",
    fill: "#FBEEE6",
    stroke: "#E59866",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -10,
    r: 35,
    fill: "#E67E22",
    stroke: "#A04000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-10 A25,25 0 0 1 -25,-35 A25,25 0 0 1 0,-10",
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-10 A15,15 0 0 1 -15,-25 A15,15 0 0 1 0,-10",
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,-10 A8,8 0 0 1 -8,-18 A8,8 0 0 1 0,-10",
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -45,
    y1: 0,
    x2: -50,
    y2: -15,
    stroke: "#E59866",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -35,
    y1: 0,
    x2: -30,
    y2: -15,
    stroke: "#E59866",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -50,
    cy: -15,
    r: 5,
    fill: "white",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -30,
    cy: -15,
    r: 5,
    fill: "white",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-52,-15 C-50,-18 -47,-18 -45,-15",
    stroke: "black",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32,-15 C-30,-18 -27,-18 -25,-15",
    stroke: "black",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45,10 C-40,15 -35,15 -30,10",
    fill: "none",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnySnail5);
export default __webpack_public_path__ + "static/media/funny-snail5.e39c68afbee08ac544024e4c0dcea0c9.svg";
export { ForwardRef as ReactComponent };